import React, { useEffect, useState } from 'react'
import firebase from 'firebase/app'
import Loader from '../../Components/Loader'
import { useHistory, useParams } from 'react-router-dom'
import { connect } from 'react-redux'
import { useTranslation } from 'react-i18next'
import {
  Tabs,
  Alert,
  Tab,
  Grid,
  TextField,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  Button,
  Snackbar,
  Tooltip,
  FormControl,
  MenuItem,
  Select,
  InputLabel,
  OutlinedInput,
  Box,
  Chip,
  Checkbox
} from '@mui/material'
import { makeStyles } from '@mui/styles'
import {
  systemColors,
  maritalStatusArray,
  englishLevelArr,
  acceptedFileSize,
  systemStylingSettings,
  height as heightArr,
  weight as weightArr,
  shoesSize as shoesSizeArr,
  clothesSize as clothesSizeArr,
  hairColor as hairColorArr,
  eyeColor as eyeColorArr
} from '../../globalVariables'
import { countries } from '../../countries'
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faPlus,
  faSyncAlt,
  faTimes,
  faTrash,
  faInfoCircle,
  faCopy
} from '@fortawesome/free-solid-svg-icons'
import { randomNumber, capitalizeString } from '../../globalFunctions'
import { vesselsList } from '../../variables/vesselsTypes'

import Header from '../Header'
import FileUploadLoader from '../../Components/FileUploadLoader/FileUploadLoader'

const db = firebase.firestore()
const storage = firebase.storage()
const storageRef = storage.ref()

const useStyles = makeStyles({
  tabsRoot: {
    justifyContent: 'center',
    marginTop: 20
  },
  tabsScroller: {
    flexGrow: 0
  },
  tabRoot: {
    maxWidth: 150,
    padding: 0,
    color: systemColors.lightBlue,
    opacity: 1,
    borderTop: `1px solid ${systemColors.lighGrey}`,
    borderBottom: `1px solid ${systemColors.lighGrey}`
  },
  tabsIndicator: {
    backgroundColor: systemColors.orange
  },
  root: {
    '& .MuiOutlinedInput-root': {
      padding: 0,
      backgroundColor: systemColors.inputColor,
      width: '100%',
      borderRadius: systemStylingSettings.borderRadius,
      '&.Mui-focused fieldset': {
        color: systemColors.darkBlue,
        borderColor: systemColors.darkBlue,
        borderWidth: systemStylingSettings.borderWidth
      }
    },
    '& .MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"] .MuiAutocomplete-input':
      {
        padding: 8
      }
  },
  labelRoot: {
    '& .MuiOutlinedInput-root': {
      borderRadius: systemStylingSettings.borderRadius
    },
    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: systemColors.darkBlue,
      borderWidth: systemStylingSettings.borderWidth
    },
    '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: systemColors.darkBlue
    },
    '& .MuiFormControl-root': {
      width: '100%'
    }
  },
  docGridContainer: {
    marginTop: 25,
    marginBottom: 25
  },
  profilePhotoMargin: {
    marginTop: 50
  },
  dialogRoot: {
    borderRadius: systemStylingSettings.borderRadius,
    backgroundColor: systemColors.background
  },
  dialogTitleRoot: {
    backgroundColor: systemColors.electric,
    color: '#ffffff'
  },
  buttonContained: {
    backgroundColor: systemColors.orange,
    borderRadius: systemStylingSettings.borderRadius,
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: systemColors.orangeDark,
      boxShadow: 'none'
    }
  },
  buttonText: {
    color: '#ffffff !important'
  },
  addDocumentButtonStartIcon: {
    color: systemColors.orange
  },
  addDocumentButtonOutlined: {
    color: systemColors.orange,
    borderColor: systemColors.orange
  },
  checkbox: {
    color: systemColors.electric
  },
  selectLabelRoot: {
    '& .MuiOutlinedInput-root': {
      borderRadius: systemStylingSettings.borderRadius,
      backgroundColor: systemColors.inputColor
    },
    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: systemColors.darkBlue,
      borderWidth: systemStylingSettings.borderWidth
    },
    '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: systemColors.darkBlue
    }
  }
})

const CrewEmployeeEditProfile = ({ agencyData, userUID }) => {
  const { docId } = useParams()
  const { t } = useTranslation()
  const classes = useStyles()
  const history = useHistory()

  const [loadedUserData, setLoadedUserData] = useState()
  const [loading, setLoading] = useState(false)
  const [selectedTab, setSelectedTab] = useState(0)
  const [contentLoaded, setContentLoaded] = useState(false)
  const [uploadedFile, setUploadedFile] = useState(false)

  // Database data states
  const [positionArr, setPositionArr] = useState([])
  const [nationalityArr, setNationalityArr] = useState([])
  const [certificatesArr, setCertificatesArr] = useState([])
  const [vesselTypesArr, setVesselTypesArr] = useState([])
  const [flagListArr, setFlagListArr] = useState([])
  const [engineTypeArr, setEngineTypeArr] = useState([])
  const [shipOwnerArr, setShipOwnerArr] = useState([])
  const [crewAgencyArr, setCrewAgencyArr] = useState([])

  // Personal data states
  const [availableFrom, setAvailableFrom] = useState('')
  // const [availableFromErr, setAvailableFromErr] = useState(false)
  const [positionObj, setPositionObj] = useState(null)
  // const [positionObjErr, setPositionObjErr] = useState(false)
  const [positionObjTwo, setPositionObjTwo] = useState(null)
  const [desiredVesselType, setDesiredVesselType] = useState([])

  const [firstName, setFirstName] = useState('')
  // const [firstNameErr, setFirstNameErr] = useState(false)
  const [lastName, setLastName] = useState('')
  // const [lastNameErr, setLastNameErr] = useState(false)
  const [middleName, setMiddleName] = useState('')
  const [birthDate, setBirthDate] = useState('')
  // const [birthDateErr, setBirthDateErr] = useState(false)
  const [homeAddress, setHomeAddress] = useState('')
  // const [homeAddressErr, setHomeAddressErr] = useState(false)
  const [mobilePhone, setMobilePhone] = useState('')
  // const [mobilePhoneErr, setMobilePhoneErr] = useState(false)
  const [email, setEmail] = useState('')
  // const [emailErr, setEmailErr] = useState(false)
  const [maritalStatus, setMritalStatus] = useState(null)
  // const [maritalStatusErr, setMaritalStatusErr] = useState(false)
  const [children, setChildren] = useState('')
  const [nationality, setNationality] = useState(null)
  // const [nationalityErr, setNationalityErr] = useState(false)
  const [nationalityOther, setNationalityOther] = useState(false)
  const [birthPlace, setBirthPlace] = useState('')
  const [nearestAirport, setNearestAirport] = useState('')
  // const [nearestAirportErr, setNearestAirportErr] = useState(false)
  const [englishLevel, setEnglishLevel] = useState(null)
  // const [englishLevelErr, setEnglishLevelErr] = useState(false)
  const [nextToKin, setNextToKin] = useState('')
  const [nextToKinPhone, setNextToKinPhone] = useState('')
  const [nextToKinEmail, setNextToKinEmail] = useState('')
  const [nextToKinAddress, setNextToKinAddress] = useState('')
  const [contractDuration, setContractDuration] = useState('')
  // const [contractDurationErr, setContractDurationErr] = useState(false)
  const [profilePhoto, setProfilePhoto] = useState('')
  const [oldProfilePhoto, setOldProfilePhoto] = useState('')
  // const [profilePhotoErr, setProfilePhotoErr] = useState(false)
  const [profilePhotoUrl, setProfilePhotoUrl] = useState('')
  const [profilePhotoSizeErr, setProfilePhotoSizeErr] = useState(false)
  const [whatsappViber, setWhatsappViber] = useState('')
  const [cityCountry, setCityCountry] = useState('')

  // Salary states
  const [minSalary, setMinSalary] = useState('')
  // const [minSalaryErr, setMinSalaryErr] = useState('')
  const [expectedSalary, setExpectedSalary] = useState('')
  // const [expectedSalaryErr, setExpectedSalaryErr] = useState('')
  const [lastSalary, setLastSalary] = useState('')
  // const [lastSalaryErr, setLastSalaryErr] = useState('')

  // Education states
  const [educationLicence, setEducationLicence] = useState('')
  const [educationNumber, setEducationNumber] = useState('')
  const [educationIssued, setEducationIssued] = useState('')
  const [educationExpires, setEducationExpires] = useState('')
  // const [educationDateErr, setEducationDateErr] = useState(false)
  const [educationCountry, setEducationCountry] = useState(null)

  // Documents states
  const [addedDocsArr, setAddedDocsArr] = useState([])
  const [documentsLinks, setDocumentsLinks] = useState([])

  // Experience states
  const [addedExperienceArr, setAddedExperienceArr] = useState([
    {
      id: randomNumber(10, true, false),
      vesselName: '',
      flag: null,
      year: '',
      vesselType: null,
      dwt: '',
      engineType: null,
      hp: '',
      rankId: null,
      fromDate: '',
      tillDate: '',
      shipOwner: null,
      crewAgency: null
    }
  ])
  const [experienceValidation, setExperienceValidation] = useState(null)

  // crew or marine agencies states
  const [addedContactsArr, setAddedContactsArr] = useState([
    {
      id: randomNumber(10, true, false),
      crewAgency: '',
      email: '',
      country: null,
      contactPerson: '',
      phone: ''
    }
  ])

  // Physical states
  const [height, setHeight] = useState(null)
  // eslint-disable-next-line
  const [heightErr, setHeightErr] = useState(false)
  const [weight, setWeight] = useState(null)
  // eslint-disable-next-line
  const [weightErr, setWeightErr] = useState(false)
  const [shoesSize, setShoesSize] = useState(null)
  // eslint-disable-next-line
  const [shoesSizeErr, setShoesSizeErr] = useState(false)
  const [clothesSize, setClothesSize] = useState(null)
  // eslint-disable-next-line
  const [clothesSizeErr, setClothesSizeErr] = useState(false)
  const [hairColor, setHairColor] = useState(null)
  // eslint-disable-next-line
  const [hairColorErr, setHairColorErr] = useState(false)
  const [eyeColor, seteyeColor] = useState(null)
  // eslint-disable-next-line
  const [eyeColorErr, setEyeColorErr] = useState(false)

  // Comment section
  const [comment, setComment] = useState('')

  // Messages states
  const [newProfilePhotoMsg, setNewProfilePhotoMsg] = useState(false)
  const [newDocumentMsg, setNewDocumentMsg] = useState(false)
  const [message, setMessage] = useState({
    status: false,
    duration: 1500,
    severity: 'success',
    message: ''
  })
  const [deleteDocumentMsg, setDeleteDocumentMsg] = useState(false)

  const [newDocumentData, setNewDocumentData] = useState([])
  const [deletingDocument, setDeletingDocument] = useState({})

  const [uploadingFile, setUploadingFile] = useState(false)
  const [uploadingFileId, setUploadingFileId] = useState('')

  // Change document title
  if (loadedUserData) {
    document.title = `${t('edit')} ${
      loadedUserData.firstName.charAt(0).toUpperCase() +
      loadedUserData.firstName.slice(1)
    } 
        ${
          loadedUserData.lastName.charAt(0).toUpperCase() +
          loadedUserData.lastName.slice(1)
        } - Seanor`
  }

  useEffect(() => {
    let shouldUpdate = true
    const getAllDataFromDatabase = () => {
      const getAndSetUserData = new Promise((resolve) => {
        db.collection('agencies')
          .doc(agencyData.id)
          .collection('employees')
          .doc(docId)
          .get()
          .then((res) => {
            let data = JSON.stringify(res.data())
            data = JSON.parse(data)

            if (shouldUpdate) {
              // Personal data
              setLoadedUserData(data)
              setAvailableFrom(data.availableFrom)

              // Find indexes and arr new array to state
              // This is work around because Selection can't change default values
              // without this modification
              if (data.desiredVesselType !== undefined) {
                let newArray = []
                data.desiredVesselType.forEach((element) => {
                  const index = vesselsList.findIndex(
                    (type) => type.name === element.name
                  )
                  newArray = [...newArray, vesselsList[index]]
                })
                setDesiredVesselType(newArray)
              }

              setFirstName(capitalizeString(data.firstName))
              setLastName(capitalizeString(data.lastName))
              setMiddleName(capitalizeString(data.middleName))
              setBirthDate(data.birthDate)
              setHomeAddress(capitalizeString(data.homeAddress))
              setMobilePhone(data.phoneMobile)
              setEmail(data.email)
              setWhatsappViber(data.whatsappViber)
              setCityCountry(data.cityCountry)
              setMritalStatus(data.maritalStatus)
              setChildren(data.children)
              setNationality(capitalizeString(data.nationality))
              setBirthPlace(capitalizeString(data.birthPlace))
              setNearestAirport(capitalizeString(data.nearestAirport))
              setEnglishLevel(data.englishLevel)
              setContractDuration(data.contractDuration)
              setNextToKin(data.nextToKin)
              setNextToKinPhone(data.nextToKinPhone)
              setNextToKinEmail(data.nextToKinEmail)
              setNextToKinAddress(data.nextToKinAddress)
              setOldProfilePhoto(data.profilePhoto)

              // Salary
              setMinSalary(data.minSalary)
              setExpectedSalary(data.expectedSalary)
              setLastSalary(data.lastSalary)

              // Education
              setEducationLicence(data.educationLicence)
              setEducationNumber(data.educationNumber)
              setEducationIssued(data.educationIssued)
              setEducationExpires(data.educationExpires)
              setEducationCountry(data.educationCountry)

              // Documents
              setAddedDocsArr(data.documentsArray)

              // Experience
              setAddedExperienceArr(data.experienceArray)

              // Contacts
              setAddedContactsArr(data.crewAgenciesArray)

              // Physical state
              setHeight(data.height)
              setWeight(data.weight)
              setShoesSize(data.shoes)
              setClothesSize(data.clothes)
              setHairColor(data.hairColor)
              seteyeColor(data.eyeColor)

              // Comment
              setComment(data.comment)
            }
            const getProfilePhotoUrl = new Promise((resolve) => {
              if (data.profilePhoto !== '') {
                storageRef
                  .child(
                    `agencies/${agencyData.id}/users-forms-uploads/${docId}/${data.profilePhoto}`
                  )
                  .getDownloadURL()
                  .then((url) => {
                    if (shouldUpdate) {
                      setProfilePhotoUrl(url)
                    }
                    resolve()
                  })
                  .catch((err) => {
                    if (shouldUpdate) {
                      setProfilePhotoUrl('')
                    }
                    console.log('Profile photo error:', err)
                    resolve()
                  })
              } else {
                resolve()
              }
            })

            const getSelectedRanksRank = new Promise((resolve) => {
              db.collection('lists')
                .doc('positions')
                .get()
                .then((res) => {
                  let positions = JSON.stringify(res.data())
                  positions = JSON.parse(positions)

                  if (data.positionId !== null) {
                    const mainRank = positions.list.find(
                      (el) => el.id === data.positionId
                    )
                    if (shouldUpdate) {
                      setPositionObj(mainRank)
                    }
                  }

                  if (data.positionTwoId !== null) {
                    const secondRank = positions.list.find(
                      (el) => el.id === data.positionTwoId
                    )
                    if (shouldUpdate) {
                      setPositionObjTwo(secondRank)
                    }
                  }
                  resolve()
                })
                .catch((err) => {
                  console.log({ message: "Can't set ranks", error: err })
                  resolve()
                })
            })

            const getDocumentsLinks = new Promise((resolve) => {
              const getLinks = data.documentsArray.map((obj) => {
                if (obj.upload !== null) {
                  // eslint-disable-next-line
                  return new Promise((res) => {
                    storageRef
                      .child(
                        `agencies/${agencyData.id}/users-forms-uploads/${docId}/${obj.upload}`
                      )
                      .getDownloadURL()
                      .then((url) => {
                        res({
                          id: obj.id,
                          url
                        })
                      })
                      .catch(() => {
                        res({
                          id: obj.id,
                          url: ''
                        })
                      })
                  })
                } else {
                  // eslint-disable-next-line
                  return
                }
              })
              Promise.all(getLinks).then((res) => {
                if (shouldUpdate) {
                  setDocumentsLinks(res)
                }
                resolve()
              })
            })

            Promise.all([
              getProfilePhotoUrl,
              getSelectedRanksRank,
              getDocumentsLinks
            ])
              .then(() => resolve())
              .catch((err) => console.log(err.message, err.error))
          })
          .catch((err) => {
            console.log({ message: "Can't get user data", error: err })
            resolve()
          })
      })

      const getPositionsList = new Promise((resolve) => {
        db.collection('lists')
          .doc('positions')
          .get()
          .then((res) => {
            let data = JSON.stringify(res.data())
            data = JSON.parse(data)
            if (shouldUpdate) {
              setPositionArr(data.list)
            }
            resolve()
          })
          .catch((err) => {
            console.log({ message: 'Positions list Error', error: err })
            resolve()
          })
      })

      const getNationalityList = new Promise((resolve) => {
        db.collection('lists')
          .doc('nationality')
          .get()
          .then((res) => {
            let data = JSON.stringify(res.data())
            data = JSON.parse(data)
            if (shouldUpdate) {
              setNationalityArr(data.list)
            }
            resolve()
          })
          .catch((err) => {
            console.log({ message: 'Nationality list Error', error: err })
            resolve()
          })
      })

      const getCertificatesList = new Promise((resolve) => {
        db.collection('certificates')
          .doc('certificates')
          .get()
          .then((res) => {
            let data = JSON.stringify(res.data())
            data = JSON.parse(data)
            if (shouldUpdate) {
              setCertificatesArr(data.list)
            }
            resolve()
          })
          .catch((err) => {
            console.log({ message: 'Certificates list Error', error: err })
            resolve()
          })
      })

      const getVesselTypeList = new Promise((resolve) => {
        db.collection('lists')
          .doc('type-of-vessel')
          .get()
          .then((res) => {
            let data = JSON.stringify(res.data())
            data = JSON.parse(data)
            if (shouldUpdate) {
              setVesselTypesArr(data.list)
            }
            resolve()
          })
          .catch((err) => {
            console.log({ message: "Can't get vessels types", error: err })
            resolve()
          })
      })

      const getFlagList = new Promise((resolve) => {
        db.collection('lists')
          .doc('flag')
          .get()
          .then((res) => {
            let data = JSON.stringify(res.data())
            data = JSON.parse(data)
            if (shouldUpdate) {
              setFlagListArr(data.list)
            }
            resolve()
          })
          .catch((err) => {
            console.log({ message: "Can't get list of flags", error: err })
            resolve()
          })
      })

      const getEngineTypesList = new Promise((resolve) => {
        db.collection('lists')
          .doc('engin-type')
          .get()
          .then((res) => {
            let data = JSON.stringify(res.data())
            data = JSON.parse(data)
            if (shouldUpdate) {
              setEngineTypeArr(data.list)
            }
            resolve()
          })
          .catch((err) => {
            console.log({ message: 'Get engines types error', error: err })
            resolve()
          })
      })

      const getShipOwnerList = new Promise((resolve) => {
        db.collection('lists')
          .doc('ship-owner')
          .get()
          .then((res) => {
            let data = JSON.stringify(res.data())
            data = JSON.parse(data)
            if (shouldUpdate) {
              setShipOwnerArr(data.list)
            }
            resolve()
          })
          .catch((err) => {
            console.log({ message: "can't get ship owner list", error: err })
            resolve()
          })
      })

      const getCrewAgencyList = new Promise((resolve) => {
        db.collection('lists')
          .doc('crew-agency')
          .get()
          .then((res) => {
            let data = JSON.stringify(res.data())
            data = JSON.parse(data)
            if (shouldUpdate) {
              setCrewAgencyArr(data.list)
            }
            resolve()
          })
          .catch((err) => {
            console.log({ message: "Can't get crew agency list", error: err })
            resolve()
          })
      })

      Promise.all([
        getAndSetUserData,
        getPositionsList,
        getNationalityList,
        getCertificatesList,
        getVesselTypeList,
        getFlagList,
        getEngineTypesList,
        getShipOwnerList,
        getCrewAgencyList
      ])
        .then(() => {
          if (shouldUpdate) {
            setContentLoaded(true)
          }
        })
        .catch((err) => {
          console.log(err.message, err.error)
          if (shouldUpdate) {
            setContentLoaded(true)
          }
        })
    }
    getAllDataFromDatabase()

    return () => {
      shouldUpdate = false
    }
  }, [agencyData, docId, uploadedFile])

  const handleTabsChange = (e, newValue) => {
    setSelectedTab(newValue)
  }

  // Update or add information of added documents inputs
  const handleInputChange = async (id, e, name, val) => {
    const newInput = addedDocsArr.map((el) => {
      if (id === el.id) {
        if (name === 'docId') {
          el[name] = val
        } else if (name === 'upload') {
          el[name] = val[0].name
          el.fileSizeError = false
          el.replaceDocument = false
        } else {
          el[name] = e.target.value
        }
      }
      return el
    })

    setAddedDocsArr(newInput)

    // Upload file to storage and update database
    if (name === 'upload') {
      setUploadingFile(true)
      setUploadingFileId(id)

      await storage
        .ref(
          `/agencies/${agencyData.id}/users-forms-uploads/${docId}/${val[0].name}`
        )
        .put(val[0])
        .then(() => {
          db.collection('agencies')
            .doc(agencyData.id)
            .collection('employees')
            .doc(docId)
            .update({
              documentsArray: newInput
            })
            .then(() => {
              const getLinks = newInput.map((obj) => {
                if (obj.upload !== null && obj.upload !== '') {
                  // eslint-disable-next-line
                  return new Promise((res) => {
                    storageRef
                      .child(
                        `agencies/${agencyData.id}/users-forms-uploads/${docId}/${obj.upload}`
                      )
                      .getDownloadURL()
                      .then((url) => {
                        res({
                          id: obj.id,
                          url
                        })
                      })
                      .catch(() => {
                        res({
                          id: obj.id,
                          url: ''
                        })
                      })
                  })
                } else {
                  // eslint-disable-next-line
                  return
                }
              })

              Promise.all(getLinks).then((res) => {
                setDocumentsLinks(res)
                setUploadingFile(false)
                setMessage({
                  status: true,
                  duration: 3000,
                  severity: 'success',
                  message: t('fileUploadedSuccessfully')
                })
              })
            })
            .catch((error) => console.error(error))
        })
        .catch((err) => {
          console.log({
            message: "Can't add certificate file to storage",
            error: err
          })
          setMessage({
            status: true,
            duration: 3000,
            severity: 'warning',
            message: t('fileWasntUploaded')
          })
        })
    }
  }

  // Validate added document date
  const validateDocDate = (index) => {
    const obj = addedDocsArr[index]
    const newValue = addedDocsArr

    if (obj.issued !== '' && obj.expires !== '') {
      if (obj.issued > obj.expires || obj.issued === obj.expires) {
        newValue[index].badDateError = true
      } else {
        newValue[index].badDateError = false
      }
    }
    setAddedDocsArr([...newValue])
  }

  // Add new document inputs
  const addNewDocument = () => {
    const blockId = randomNumber(10, true, false)
    setAddedDocsArr([
      ...addedDocsArr,
      {
        id: blockId,
        docId: null,
        number: '',
        placeIssue: '',
        issued: '',
        expires: '',
        upload: ''
      }
    ])
  }

  // Find element validation status and return boolean
  const findValidation = (id, name) => {
    if (experienceValidation !== null) {
      let result = false
      experienceValidation.map((el) => {
        if (id === el.id) {
          return (result = el[name])
        }
        return el
      })
      return result
    } else {
      return false
    }
  }

  // Validate added experience date
  const validateExperienceDate = (index) => {
    const obj = addedExperienceArr[index]
    if (obj.fromDate !== '' || obj.tillDate !== '') {
      if (obj.fromDate > obj.tillDate || obj.fromDate === obj.tillDate) {
        return true
      } else {
        return false
      }
    }
  }

  // Add new experience inputs
  const addNewExperience = () => {
    const blockId = randomNumber(10, true, false)
    setAddedExperienceArr([
      ...addedExperienceArr,
      {
        id: blockId,
        vesselName: '',
        flag: null,
        year: '',
        vesselType: null,
        dwt: '',
        engineType: null,
        hp: '',
        rankId: null,
        fromDate: '',
        tillDate: '',
        shipOwner: null,
        crewAgency: null
      }
    ])
  }

  // Remove added experience
  const removeExperience = (index) => {
    if (addedExperienceArr.length > 1) {
      const values = [...addedExperienceArr]
      values.splice(index, 1)
      setAddedExperienceArr(values)
    }
  }

  // Update or add informations of added experience inputs
  const addExperienceInputs = (id, e, name, val) => {
    const newInput = addedExperienceArr.map((el) => {
      if (id === el.id) {
        if (name === 'vesselType') {
          el[name] = val
        } else if (name === 'engineType') {
          el[name] = val
        } else if (name === 'rankId') {
          el[name] = val
        } else if (name === 'flag') {
          el[name] = val
        } else if (name === 'flagOther') {
          el.flag = e.target.value
        } else if (name === 'shipOwner') {
          el[name] = val
        } else if (name === 'shipOwnerOther') {
          el.shipOwner = e.target.value
        } else if (name === 'crewAgency') {
          el[name] = val
        } else if (name === 'crewAgencyOther') {
          el.crewAgency = e.target.value
        } else {
          el[name] = e.target.value
        }
      }
      return el
    })

    setAddedExperienceArr(newInput)
  }

  // Experience fields validation
  const experienceValidationSet = (id, name, bool) => {
    if (experienceValidation !== null) {
      if (experienceValidation.some((el) => el.id === id)) {
        const newInput = experienceValidation.map((el) => {
          if (id === el.id) {
            if (name === 'flag') {
              el.flag = bool
            } else if (name === 'shipOwner') {
              el.shipOwner = bool
            } else if (name === 'crewAgency') {
              el.crewAgency = bool
            }
          }

          return el
        })

        setExperienceValidation(newInput)
      } else {
        if (name === 'flag') {
          setExperienceValidation([
            ...experienceValidation,
            { id, flag: bool, shipOwner: false, crewAgency: false }
          ])
        } else if (name === 'shipOwner') {
          setExperienceValidation([
            ...experienceValidation,
            { id, flag: false, shipOwner: bool, crewAgency: false }
          ])
        } else if (name === 'crewAgency') {
          setExperienceValidation([
            ...experienceValidation,
            { id, flag: false, shipOwner: false, crewAgency: true }
          ])
        }
      }
    } else {
      if (name === 'flag') {
        setExperienceValidation([
          { id, flag: bool, shipOwner: false, crewAgency: false }
        ])
      } else if (name === 'shipOwner') {
        setExperienceValidation([
          { id, flag: false, shipOwner: bool, crewAgency: false }
        ])
      } else if (name === 'crewAgency') {
        setExperienceValidation([
          { id, flag: false, shipOwner: false, crewAgency: true }
        ])
      }
    }
  }

  // Update or add information of contacts inputs
  const addContactInput = (id, e, name, val) => {
    const newInput = addedContactsArr.map((el) => {
      if (id === el.id) {
        if (name === 'country') {
          el[name] = val
        } else {
          el[name] = e.target.value
        }
      }
      return el
    })

    setAddedContactsArr(newInput)
  }

  // Remove added experience
  const removeContact = (index) => {
    if (addedContactsArr.length > 1) {
      const values = [...addedContactsArr]
      values.splice(index, 1)
      setAddedContactsArr(values)
    }
  }

  // Add new crew or marine agencies inputs
  const addNewContact = () => {
    const blockId = randomNumber(10, true, false)
    setAddedContactsArr([
      ...addedContactsArr,
      {
        id: blockId,
        crewAgency: '',
        email: '',
        country: null,
        contactPerson: '',
        phone: ''
      }
    ])
  }

  const uploadNewProfilePhoto = () => {
    setNewProfilePhotoMsg(false)
    setLoading(true)

    const uploadPhoto = () => {
      const updateDatabase = new Promise((resolve) => {
        db.collection('agencies')
          .doc(agencyData.id)
          .collection('employees')
          .doc(docId)
          .update({
            profilePhoto: profilePhoto[0].name,
            date: new Date()
          })
          .then(() => resolve())
          .catch((err) => {
            console.log({ message: "Can't update profile pgoto", error: err })
            resolve()
          })
      })
      const uploadProfilePhoto = new Promise((resolve) => {
        storage
          .ref(
            `/agencies/${agencyData.id}/users-forms-uploads/${docId}/${profilePhoto[0].name}`
          )
          .put(profilePhoto[0])
          .then(() => resolve())
          .catch((err) => {
            console.log({ message: "Can't upload file", error: err })
            resolve()
          })
      })

      Promise.all([updateDatabase, uploadProfilePhoto])
        .then(() => {
          setLoading(false)
          setUploadedFile(!uploadedFile)
        })
        .catch((err) => {
          console.log(err.message, err.err)
          setLoading(false)
        })
    }

    if (profilePhotoUrl !== '' && profilePhotoUrl !== null) {
      storageRef
        .child(
          `/agencies/${agencyData.id}/users-forms-uploads/${docId}/${oldProfilePhoto}`
        )
        .delete()
        .then(() => uploadPhoto())
        .catch((err) => {
          console.log("Can't delete old profile photo", err)
          setProfilePhoto('')
          setLoading(false)
        })
    } else {
      uploadPhoto()
    }
  }

  // Send data to server
  const submit = () => {
    setLoading(true)

    const addDataToDatabase = new Promise((resolve) => {
      db.collection('agencies')
        .doc(agencyData.id)
        .collection('employees')
        .doc(docId)
        .update({
          formTyle: agencyData.type,
          date: new Date(),
          availableFrom: availableFrom,
          positionId: positionObj.id,
          positionTwoId: positionObjTwo !== null ? positionObjTwo.id : null,
          firstName: firstName.toLowerCase(),
          lastName: lastName.toLowerCase(),
          middleName: middleName.toLowerCase(),
          birthDate: birthDate,
          homeAddress: homeAddress.toLowerCase(),
          phoneMobile: mobilePhone,
          email: email.toLowerCase(),
          maritalStatus: maritalStatus,
          children: children,
          nationality: nationality !== null ? nationality.toLowerCase() : null,
          birthPlace: birthPlace.toLowerCase(),
          nearestAirport: nearestAirport.toLowerCase(),
          englishLevel: englishLevel,
          contractDuration: contractDuration,
          nextToKinPhone: nextToKinPhone,
          nextToKin: nextToKin,
          nextToKinAddress: nextToKinAddress,
          nextToKinEmail: nextToKinEmail,
          minSalary: minSalary,
          expectedSalary: expectedSalary,
          lastSalary: lastSalary,
          educationLicence: educationLicence,
          educationNumber: educationNumber,
          educationIssued: educationIssued,
          educationExpires: educationExpires,
          educationCountry: educationCountry,
          documentsArray: addedDocsArr,
          experienceArray: addedExperienceArr,
          crewAgenciesArray: addedContactsArr,
          height: height,
          weight: weight,
          shoes: shoesSize,
          clothes: clothesSize,
          hairColor: hairColor,
          eyeColor: eyeColor,
          comment: comment,
          whatsappViber: whatsappViber,
          cityCountry: cityCountry,
          desiredVesselType
        })
        .then(() => resolve())
        .catch((err) => {
          console.log({ message: "Can't add data to database", error: err })
          resolve()
        })
    })

    // Check if flag, ship owner and crew agencies exsist in database and if not, add to it
    const addAdditionalFieldsToDatabase = new Promise((resolve) => {
      const promise = addedExperienceArr.forEach((el) => {
        if (flagListArr.includes(el.flag) === false && el.flag !== null) {
          db.collection('lists')
            .doc('flag')
            .set({
              list: flagListArr.concat(el.flag)
            })
            .catch((err) => console.log('Add Flag error:', err))
        }
        if (
          shipOwnerArr.includes(el.shipOwner) === false &&
          el.shipOwner !== null
        ) {
          db.collection('lists')
            .doc('ship-owner')
            .set({
              list: shipOwnerArr.concat(el.shipOwner)
            })
            .catch((err) => console.log('Add ship owner error:', err))
        }

        if (
          crewAgencyArr.includes(el.crewAgency) === false &&
          el.crewAgency !== null
        ) {
          db.collection('lists')
            .doc('crew-agency')
            .set({
              list: crewAgencyArr.concat(el.crewAgency)
            })
            .catch((err) => console.log('Add crew agency error:', err))
        }
      })

      Promise.all([promise]).then(() => resolve(true))
    })

    const addNewNationalityToDatabase = new Promise((resolve) => {
      // Check if nationality exist in list
      const existNationality = nationalityArr.includes(nationality)
      if (!existNationality) {
        const newNationalityList = [...nationalityArr, nationality]
        db.collection('lists')
          .doc('nationality')
          .update({
            list: newNationalityList
          })
          .then(() => resolve())
          .catch((error) => {
            console.log("Can't update nationality list", error)
            resolve()
          })
      } else {
        resolve()
      }
    })

    Promise.all([
      addDataToDatabase,
      addAdditionalFieldsToDatabase,
      addNewNationalityToDatabase
    ])
      .then(() => {
        setLoading(false)
        setMessage({
          status: true,
          duration: 5000,
          severity: 'success',
          message: t('dataSaveSuccess')
        })
      })
      .catch((err) => {
        setLoading(false)
        console.log(err.message, err.error)
      })
  }

  const cancelAndReturnToUser = () => {
    history.push(`/${agencyData.id}/dashboard/${userUID}`)
  }

  const deleteAddedDocument = () => {
    setDeleteDocumentMsg(false)
    setLoading(true)
    const document = addedDocsArr.find((el) => el.id === deletingDocument.id)

    const deleteDocumentFromStorage = new Promise((resolve) => {
      storageRef
        .child(
          `/agencies/${agencyData.id}/users-forms-uploads/${docId}/${document.upload}`
        )
        .delete()
        .then(() => resolve())
        .catch((err) => {
          console.log({ message: "Can't delete document", error: err })
          resolve()
        })
    })

    const deleteDocumentData = new Promise((resolve) => {
      const newArr = [...addedDocsArr]
      newArr.splice(deletingDocument.index, 1)

      db.collection('agencies')
        .doc(agencyData.id)
        .collection('employees')
        .doc(docId)
        .update({
          documentsArray: addedDocsArr,
          date: new Date()
        })
        .then(() => {
          resolve()
        })
        .catch((err) => {
          console.log({ message: "Can't update documents data", error: err })
          resolve()
        })
    })

    Promise.all([deleteDocumentFromStorage, deleteDocumentData])
      .then(() => {
        setLoading(false)
        setUploadedFile(!uploadedFile)
        setMessage({
          status: true,
          duration: 1500,
          severity: 'success',
          message: t('documentDeleteSuccsess')
        })
      })
      .catch((err) => {
        console.log(err.message, err.error)
        setLoading(false)
        setUploadedFile(!uploadedFile)
      })
  }

  // Let filter position by ID and by name
  const _positionsOptions = createFilterOptions()
  const positionsOptions = (positionArr, state) => {
    const result = _positionsOptions(positionArr, state)

    if (result.length === 0) {
      return _positionsOptions(positionArr, {
        ...state,
        getOptionLabel: (o) => o.id.toString()
      })
    }

    return result
  }

  // Let filter certificates by ID and by name
  const _cerificatesOptions = createFilterOptions({
    stringify: (option) => `${option.id} ${option.name}`
  })
  const certificatesOptions = (certificatesArr, state) => {
    const result = _cerificatesOptions(certificatesArr, state)

    if (result.length === 0) {
      return _cerificatesOptions(certificatesArr, {
        ...state,
        getOptionLabel: (o) => o.id.toString()
      })
    }

    return result
  }

  // Update state to set file size error
  const setFileSizeError = (index, value) => {
    const newValue = addedDocsArr
    newValue[index].fileSizeError = value
    setAddedDocsArr([...newValue])
  }

  const getDocumentFileUrl = (id) => {
    let link = ''
    documentsLinks.find((el) => {
      if (el !== undefined && el.id === id) {
        link = el.url
      }
      return link
    })
    return link
  }

  const uploadNewDocument = () => {
    setLoading(true)
    setUploadingFile(true)
    setUploadingFileId(newDocumentData.id)
    const document = addedDocsArr.find((el) => el.id === newDocumentData.id)

    const addDocument = () => {
      const newUpdatedDocumentsArray = addedDocsArr.map((el) => {
        if (el.id === newDocumentData.id) {
          el.upload = newDocumentData.file[0].name
          el.replaceDocument = false
          el.fileSizeError = false
        }
        return el
      })
      const updateDatabase = new Promise((resolve) => {
        db.collection('agencies')
          .doc(agencyData.id)
          .collection('employees')
          .doc(docId)
          .update({
            documentsArray: newUpdatedDocumentsArray,
            date: new Date()
          })
          .then(() => resolve())
          .catch((err) => {
            console.log({ message: "Can't update certificates", error: err })
            resolve()
          })
      })

      const uploadFile = new Promise((resolve) => {
        storage
          .ref(
            `/agencies/${agencyData.id}/users-forms-uploads/${docId}/${newDocumentData.file[0].name}`
          )
          .put(newDocumentData.file[0])
          .then(() => {
            const getLinks = newUpdatedDocumentsArray.map((obj) => {
              if (obj.upload !== null && obj.upload !== '') {
                // eslint-disable-next-line
                return new Promise((res) => {
                  storageRef
                    .child(
                      `agencies/${agencyData.id}/users-forms-uploads/${docId}/${obj.upload}`
                    )
                    .getDownloadURL()
                    .then((url) => {
                      res({
                        id: obj.id,
                        url
                      })
                    })
                    .catch(() => {
                      res({
                        id: obj.id,
                        url: ''
                      })
                    })
                })
              } else {
                // eslint-disable-next-line
                return
              }
            })
            Promise.all(getLinks)
              .then((res) => {
                setDocumentsLinks(res)
                resolve()
              })
              .catch((error) => {
                console.log(error)
                resolve()
              })
          })
          .catch((err) => {
            console.log({ message: "Can't upload file", error: err })
            resolve()
          })
      })

      Promise.all([updateDatabase, uploadFile])
        .then(() => {
          setNewDocumentMsg(false)
          setNewDocumentData({})
          setLoading(false)
          setUploadedFile(!uploadedFile)
          setUploadingFile(false)
          setMessage({
            status: true,
            duration: 5000,
            severity: 'success',
            message: t('documentUploadSuccess')
          })
        })
        .catch((err) => {
          setNewDocumentMsg(false)
          console.log(err.message, err.err)
          setNewDocumentData({})
          setLoading(false)
          setMessage({
            status: true,
            duration: 15000,
            severity: 'warning',
            message: t('cantUploadDocument')
          })
        })
    }

    if (document && document.upload !== '' && document.upload !== null) {
      storageRef
        .child(
          `/agencies/${agencyData.id}/users-forms-uploads/${docId}/${document.upload}`
        )
        .delete()
        .then(() => addDocument())
        .catch((error) => {
          console.log("Can't delete old certificate file", error)
          if (error.code === 'storage/object-not-found') {
            addDocument()
          }
          setNewDocumentData({})
          setNewDocumentMsg(false)
          setLoading(false)
        })
    } else {
      addDocument()
    }
  }

  // Update state to show new file upload input
  const replaceDocumentWithNew = (index) => {
    const newValue = addedDocsArr
    newValue[index].replaceDocument = true
    setAddedDocsArr([...newValue])
  }

  // Update state to hide new file upload input
  const cancelDocumentReplaceWithNew = (index) => {
    const newValue = addedDocsArr
    newValue[index].replaceDocument = false
    setAddedDocsArr([...newValue])
  }

  // Remove added document
  const removeDocument = async (index, file) => {
    if (
      addedDocsArr[index].id !== 'passport' &&
      addedDocsArr[index].id !== 'book' &&
      addedDocsArr[index].id !== 'stcw' &&
      addedDocsArr[index].id !== 'med'
    ) {
      const values = [...addedDocsArr]
      values.splice(index, 1)

      if (file === '') {
        setAddedDocsArr(values)
        setLoading(false)
      } else {
        await storage
          .ref(
            `/agencies/${agencyData.id}/users-forms-uploads/${docId}/${file}`
          )
          .delete()
          .then(() => {
            db.collection('agencies')
              .doc(agencyData.id)
              .collection('employees')
              .doc(docId)
              .update({
                documentsArray: values
              })
              .then(() => {
                const getLinks = values.map((obj) => {
                  if (obj.upload !== null) {
                    // eslint-disable-next-line
                    return new Promise((res) => {
                      storageRef
                        .child(
                          `agencies/${agencyData.id}/users-forms-uploads/${docId}/${obj.upload}`
                        )
                        .getDownloadURL()
                        .then((url) => {
                          res({
                            id: obj.id,
                            url
                          })
                        })
                        .catch(() => {
                          res({
                            id: obj.id,
                            url: ''
                          })
                        })
                    })
                  } else {
                    // eslint-disable-next-line
                    return
                  }
                })
                Promise.all(getLinks).then((res) => {
                  setAddedDocsArr(values)
                  setDocumentsLinks(res)
                  setMessage({
                    status: true,
                    duration: 3000,
                    severity: 'success',
                    message: t('fileDeletedSuccessfully')
                  })
                })
              })
          })
          .catch((error) => {
            console.log("Can't delete reference file from storage", error)
          })
        setAddedDocsArr(values)
      }
    }
  }

  /**
   * Add new experience line with parent experience data
   */
  const copyExperience = (parent) => {
    const blockId = randomNumber(10, true, false)

    setAddedExperienceArr([
      ...addedExperienceArr,
      {
        id: blockId,
        vesselName: parent.vesselName,
        flag: parent.flag,
        year: parent.year,
        vesselType: parent.vesselType,
        dwt: parent.dwt,
        engineType: parent.engineType,
        hp: parent.hp,
        rankId: parent.rankId,
        fromDate: parent.fromDate,
        tillDate: parent.tillDate,
        shipOwner: parent.shipOwner,
        crewAgency: parent.crewAgency
      }
    ])
  }

  if (!contentLoaded) {
    return <Loader />
  }

  return (
    <div>
      {loading && <Loader />}
      <Header userExist />
      {/* Popup messages */}
      {/* Profile photo */}
      <Dialog open={newProfilePhotoMsg} classes={{ paper: classes.dialogRoot }}>
        <DialogTitle classes={{ root: classes.dialogTitleRoot }}>
          {t('areYouShure')}
        </DialogTitle>
        <DialogContent>{t('profilePhotoPopupMessage')}</DialogContent>
        <DialogActions>
          <Button onClick={() => uploadNewProfilePhoto()}>
            {t('continue')}
          </Button>
          <Button
            onClick={() => {
              setNewProfilePhotoMsg(false)
              setProfilePhoto('')
            }}
          >
            {t('cancel')}
          </Button>
        </DialogActions>
      </Dialog>
      {/* Documents */}
      <Dialog open={newDocumentMsg} classes={{ paper: classes.dialogRoot }}>
        <DialogTitle classes={{ root: classes.dialogTitleRoot }}>
          {t('areYouShure')}
        </DialogTitle>
        <DialogContent>{t('uploadNewDocumentPopupMessage')}</DialogContent>
        <DialogActions>
          <Button onClick={() => uploadNewDocument()}>{t('continue')}</Button>
          <Button
            onClick={() => {
              setNewDocumentMsg(false)
              setNewDocumentData([])
            }}
          >
            {t('cancel')}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={deleteDocumentMsg} classes={{ paper: classes.dialogRoot }}>
        <DialogTitle classes={{ root: classes.dialogTitleRoot }}>
          {t('areYouShure')}
        </DialogTitle>
        <DialogContent>{t('deleteDocuemtentFromDatabase')}</DialogContent>
        <DialogActions>
          <Button onClick={() => deleteAddedDocument()}>{t('continue')}</Button>
          <Button
            onClick={() => {
              setDeleteDocumentMsg(false)
              setDeletingDocument({})
            }}
          >
            {t('cancel')}
          </Button>
        </DialogActions>
      </Dialog>
      {/* Snackbars */}
      <Snackbar
        open={message.status}
        autoHideDuration={message.duration}
        anchorOrigin={{ horizontal: 'center', vertical: 'top' }}
        onClose={() => setMessage({ ...message, status: false })}
      >
        <Alert
          severity={message.severity}
          onClose={() => setMessage({ ...message, status: false })}
        >
          {message.message}
        </Alert>
      </Snackbar>
      {/* Top buttons */}
      <div className='editEmployee__buttons'>
        <Button
          className='editEmployee__buttons-button'
          variant='contained'
          size='small'
          classes={{
            contained: classes.buttonContained,
            sizeSmall: classes.buttonText
          }}
          onClick={() => submit()}
        >
          {t('save')}
        </Button>
        <Button
          className='editEmployee__buttons-button'
          onClick={() => cancelAndReturnToUser()}
        >
          {t('cancel')}
        </Button>
      </div>
      {/* Tabs menu */}
      <Tabs
        value={selectedTab}
        onChange={handleTabsChange}
        variant='scrollable'
        scrollButtons='auto'
      >
        <Tab label={t('basicInfo')} />
        <Tab label={t('salary')} />
        <Tab label={t('education')} />
        <Tab label={t('documents')} />
        <Tab label={t('experience')} />
        <Tab label={t('crewOrMarineAgencies')} />
        <Tab label={t('physicalState')} />
        <Tab label={t('coverLetterComments')} />
      </Tabs>

      <div>
        {/* Personal data section */}
        {selectedTab === 0 && (
          <div className='editUser__tabSection'>
            <Grid
              container
              spacing={2}
              classes={{ root: classes.docGridContainer }}
            >
              {/* Available from */}
              <Grid item xs={12} sm={6} md={2}>
                <TextField
                  // required
                  size='small'
                  variant='outlined'
                  type='date'
                  label={t('availableFrom')}
                  value={availableFrom}
                  InputLabelProps={{
                    shrink: true
                  }}
                  onChange={(e) => setAvailableFrom(e.target.value)}
                  fullWidth
                  // helperText={availableFromErr && t('required')}
                  // error={availableFromErr ? true : false}
                />
              </Grid>

              {/* Main rank */}
              <Grid item xs={12} sm={6} md={3}>
                <Autocomplete
                  options={positionArr}
                  filterOptions={positionsOptions}
                  getOptionLabel={(option) => option.name}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      // required
                      size='small'
                      fullWidth
                      label={t('mainRank')}
                      variant='outlined'
                      // helperText={positionObjErr && t('required')}
                      // error={positionObjErr ? true : false}
                    />
                  )}
                  value={positionObj}
                  onChange={(e, val) => {
                    val && setPositionObj(val)
                  }}
                />
              </Grid>

              {/* Second rank */}
              <Grid item xs={12} sm={6} md={3}>
                <Autocomplete
                  filterOptions={positionsOptions}
                  options={positionArr}
                  getOptionLabel={(option) => option.name}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      size='small'
                      fullWidth
                      label={t('secondRank')}
                      variant='outlined'
                      helperText={t('optional')}
                    />
                  )}
                  value={positionObjTwo}
                  onChange={(e, val) => {
                    val && setPositionObjTwo(val)
                  }}
                />
              </Grid>

              {/* Desired vessel types */}
              <Grid item xs={12} sm={6} md={3}>
                <FormControl fullWidth size='small' variant='outlined'>
                  <InputLabel id='desiredVesselType'>
                    {t('desiredVesselType')}
                  </InputLabel>
                  <Select
                    labelId='desiredVesselType'
                    multiple
                    fullWidth
                    value={desiredVesselType}
                    onChange={(e) => setDesiredVesselType(e.target.value)}
                    // onChange={(e) => setDesiredVesselType(e.target.value)}
                    input={<OutlinedInput label={t('desiredVesselType')} />}
                    renderValue={(selected) => {
                      return (
                        <Box
                          sx={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            gap: 2,
                            width: 300
                          }}
                        >
                          {selected.map((value, index) => (
                            <Chip key={index} label={t(value.name)} />
                          ))}
                        </Box>
                      )
                    }}
                  >
                    {vesselsList.map((type, index) => (
                      <MenuItem
                        key={index}
                        value={type}
                        style={{ marginLeft: type.type !== 'group' && 20 }}
                      >
                        <Checkbox
                          color='default'
                          classes={{ root: classes.checkbox }}
                          checked={
                            desiredVesselType !== undefined &&
                            // console.log(type)}
                            // console.log(desiredVesselType.indexOf(type))}
                            // desiredVesselType.findIndex((index) => index.name === type.name) > -1}
                            desiredVesselType.indexOf(type) > -1
                          }
                        />
                        <div
                          style={{
                            fontWeight: type.type === 'group' && 'bold'
                          }}
                        >
                          {t(type.name)}
                        </div>
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>

            <Grid container spacing={2}>
              <Grid item xs={12} sm={6} md={2}>
                <TextField
                  // required
                  size='small'
                  variant='outlined'
                  type='text'
                  label={t('firstName')}
                  value={firstName}
                  onChange={(e) => setFirstName(e.target.value)}
                  fullWidth
                  // helperText={firstNameErr && t('required')}
                  // error={firstNameErr ? true : false}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={2}>
                <TextField
                  // required
                  size='small'
                  variant='outlined'
                  type='text'
                  label={t('lastName')}
                  value={lastName}
                  onChange={(e) => setLastName(e.target.value)}
                  fullWidth
                  // helperText={lastNameErr && t('required')}
                  // error={lastNameErr ? true : false}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={2}>
                <TextField
                  size='small'
                  variant='outlined'
                  type='text'
                  label={t('middleName')}
                  value={middleName}
                  onChange={(e) => setMiddleName(e.target.value)}
                  fullWidth
                />
              </Grid>

              <Grid item xs={12} sm={6} md={2}>
                <TextField
                  // required
                  size='small'
                  variant='outlined'
                  type='date'
                  label={t('birthDate')}
                  value={birthDate}
                  InputLabelProps={{
                    shrink: true
                  }}
                  onChange={(e) => setBirthDate(e.target.value)}
                  fullWidth
                  // helperText={birthDateErr && t('required')}
                  // error={birthDateErr ? true : false}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={2}>
                <TextField
                  // required
                  size='small'
                  variant='outlined'
                  type='text'
                  label={t('homeAddress')}
                  value={homeAddress}
                  onChange={(e) => setHomeAddress(e.target.value)}
                  fullWidth
                  // helperText={homeAddressErr && t('required')}
                  // error={homeAddressErr ? true : false}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={2}>
                <TextField
                  // required
                  size='small'
                  variant='outlined'
                  type='tel'
                  label={t('phone')}
                  placeholder='+370 ...'
                  value={mobilePhone}
                  onChange={(e) => setMobilePhone(e.target.value)}
                  fullWidth
                  // helperText={mobilePhoneErr && t('required')}
                  // error={mobilePhoneErr ? true : false}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={2}>
                <TextField
                  // required
                  size='small'
                  variant='outlined'
                  type='email'
                  label={t('email')}
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  fullWidth
                  // helperText={emailErr && t('required')}
                  // error={emailErr ? true : false}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={2}>
                <TextField
                  size='small'
                  variant='outlined'
                  type='text'
                  label={t('whatsappOrViberNo')}
                  value={whatsappViber}
                  onChange={(e) => setWhatsappViber(e.target.value)}
                  fullWidth
                />
              </Grid>

              <Grid item xs={12} sm={6} md={2}>
                <TextField
                  size='small'
                  variant='outlined'
                  type='text'
                  label={t('cityCountry')}
                  value={cityCountry}
                  onChange={(e) => setCityCountry(e.target.value)}
                  fullWidth
                />
              </Grid>

              <Grid item xs={12} sm={6} md={2}>
                <Autocomplete
                  style={{ padding: 0 }}
                  options={maritalStatusArray}
                  getOptionLabel={(option) => option}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      // required
                      size='small'
                      fullWidth
                      label={t('maritalStatus')}
                      variant='outlined'
                      // helperText={maritalStatusErr && t('required')}
                      // error={maritalStatusErr ? true : false}
                    />
                  )}
                  value={maritalStatus}
                  onChange={(e, val) => {
                    val && setMritalStatus(val)
                  }}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={1}>
                <TextField
                  size='small'
                  variant='outlined'
                  type='number'
                  label={t('children')}
                  value={children}
                  onChange={(e) => setChildren(e.target.value)}
                  fullWidth
                />
              </Grid>

              {/* nationality */}
              <Grid item xs={12} sm={6} md={2}>
                <Autocomplete
                  style={{ padding: 0 }}
                  options={nationalityArr}
                  getOptionLabel={(option) => option}
                  value={nationality}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      required
                      size='small'
                      fullWidth
                      label={t('nationality')}
                      variant='outlined'
                      // helperText={nationalityErr && t('required')}
                      // error={!!nationalityErr}
                    />
                  )}
                  onChange={(e, val) => {
                    if (val) {
                      if (val === 'Other') {
                        setNationalityOther(true)
                      } else {
                        setNationalityOther(false)
                        setNationality(val)
                      }
                    }
                  }}
                />
              </Grid>

              {nationalityOther ? (
                <Grid item xs={12} sm={6} md={2}>
                  <TextField
                    required
                    size='small'
                    variant='outlined'
                    type='text'
                    label={t('enterNationality')}
                    // value={nationality !== null ? nationality : ''}
                    onChange={(e) => setNationality(e.target.value)}
                    fullWidth
                    // helperText={nationalityErr && t('required')}
                    // error={!!nationalityErr}
                  />
                </Grid>
              ) : null}

              <Grid item xs={12} sm={6} md={1}>
                <TextField
                  size='small'
                  variant='outlined'
                  type='text'
                  label={t('birthPlace')}
                  value={birthPlace}
                  onChange={(e) => setBirthPlace(e.target.value)}
                  fullWidth
                />
              </Grid>

              <Grid item xs={12} sm={6} md={2}>
                <TextField
                  // required
                  size='small'
                  variant='outlined'
                  type='text'
                  label={t('nearestAirpot')}
                  value={nearestAirport}
                  onChange={(e) => setNearestAirport(e.target.value)}
                  fullWidth
                  // helperText={nearestAirportErr && t('required')}
                  // error={nearestAirportErr ? true : false}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={2}>
                <Autocomplete
                  options={englishLevelArr}
                  getOptionLabel={(option) => option}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      // required
                      size='small'
                      label={t('englishLevel')}
                      variant='outlined'
                      // helperText={englishLevelErr && t('required')}
                      // error={englishLevelErr ? true : false}
                    />
                  )}
                  value={englishLevel}
                  onChange={(e, val) => {
                    val && setEnglishLevel(val)
                  }}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={2}>
                <TextField
                  // required
                  size='small'
                  variant='outlined'
                  type='number'
                  label={t('desiredContractDuration')}
                  value={contractDuration}
                  onChange={(e) => setContractDuration(e.target.value)}
                  fullWidth
                  // helperText={contractDurationErr && t('required')}
                  // error={contractDurationErr ? true : false}
                />
              </Grid>
            </Grid>

            <Grid
              container
              spacing={2}
              classes={{ root: classes.docGridContainer }}
            >
              <Grid item xs={12} sm={6} md={2}>
                <TextField
                  size='small'
                  variant='outlined'
                  type='text'
                  label={t('nextToKin')}
                  value={nextToKin}
                  onChange={(e) => setNextToKin(e.target.value)}
                  fullWidth
                />
              </Grid>

              <Grid item xs={12} sm={6} md={2}>
                <TextField
                  size='small'
                  variant='outlined'
                  type='tel'
                  label={t('nextToKinPhone')}
                  placeholder='+370 ...'
                  value={nextToKinPhone}
                  onChange={(e) => setNextToKinPhone(e.target.value)}
                  fullWidth
                />
              </Grid>

              <Grid item xs={12} sm={6} md={2}>
                <TextField
                  size='small'
                  variant='outlined'
                  type='email'
                  label={t('nextToKinEmail')}
                  value={nextToKinEmail}
                  onChange={(e) => setNextToKinEmail(e.target.value)}
                  fullWidth
                />
              </Grid>

              <Grid item xs={12} sm={6} md={3}>
                <TextField
                  size='small'
                  variant='outlined'
                  type='text'
                  label={t('nextToKinAddress')}
                  value={nextToKinAddress}
                  onChange={(e) => setNextToKinAddress(e.target.value)}
                  fullWidth
                />
              </Grid>
            </Grid>

            {/* Profile photo upload */}
            <Grid
              container
              spacing={2}
              alignItems='center'
              justifyContent='center'
              classes={{ root: classes.profilePhotoMargin }}
            >
              <Grid item>
                {profilePhotoUrl !== '' ? (
                  <img
                    className='vesselCrewForm__upload-photo-img'
                    src={profilePhotoUrl}
                    alt='profile'
                  />
                ) : (
                  <div className='photo-box'>{t('photo')}</div>
                )}
              </Grid>

              <Grid item>
                <TextField
                  // required
                  size='small'
                  variant='outlined'
                  type='file'
                  label={t('profilePhoto')}
                  key={profilePhoto}
                  InputLabelProps={{
                    shrink: true
                  }}
                  onChange={(e) => {
                    if (e.target.files.length > 0) {
                      if (e.target.files[0].size > acceptedFileSize) {
                        setProfilePhotoSizeErr(true)
                      } else {
                        setProfilePhoto(e.target.files)
                        setProfilePhotoSizeErr(false)
                        setNewProfilePhotoMsg(true)
                      }
                    }
                  }}
                  fullWidth
                  inputProps={{
                    accept: '.png, .jpg, .jpeg'
                  }}
                  helperText={
                    profilePhotoSizeErr ? t('toBigFile') : t('acceptFormat')
                  }
                  // helperText={profilePhotoErr ? t('required') : profilePhotoSizeErr ? t('toBigFile') : t('acceptFormat')}
                  // error={profilePhotoErr ? true : false}
                />

                {profilePhoto !== '' && (
                  <div className='addNewEmployee__upload-msg'>
                    {t('selectedFile')}: {profilePhoto[0].name}
                  </div>
                )}
              </Grid>
            </Grid>
          </div>
        )}
        {/* Salary section */}
        {selectedTab === 1 && (
          <div className='editUser__tabSection'>
            <Grid
              container
              spacing={2}
              classes={{ root: classes.docGridContainer }}
            >
              <Grid item xs={12} sm={6} md={2}>
                <TextField
                  // required
                  size='small'
                  InputProps={{ inputProps: { min: 0 } }}
                  variant='outlined'
                  type='number'
                  label={t('minimum')}
                  value={minSalary}
                  onChange={(e) => setMinSalary(e.target.value)}
                  fullWidth
                  // helperText={minSalaryErr ? t('required') : t('perMonth')}
                  // error={minSalaryErr ? true : false}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={2}>
                <TextField
                  // required
                  size='small'
                  InputProps={{ inputProps: { min: 0 } }}
                  variant='outlined'
                  type='number'
                  label={t('expected')}
                  value={expectedSalary}
                  onChange={(e) => setExpectedSalary(e.target.value)}
                  fullWidth
                  // helperText={expectedSalaryErr ? t('required') : t('perMonth')}
                  // error={expectedSalaryErr ? true : false}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={2}>
                <TextField
                  // required
                  size='small'
                  InputProps={{ inputProps: { min: 0 } }}
                  variant='outlined'
                  type='number'
                  label={t('lastSalary')}
                  value={lastSalary}
                  onChange={(e) => setLastSalary(e.target.value)}
                  fullWidth
                  // helperText={lastSalaryErr ? t('required') : t('perMonth')}
                  // error={lastSalaryErr ? true : false}
                />
              </Grid>
            </Grid>
          </div>
        )}
        {/* Education section */}
        {selectedTab === 2 && (
          <div className='editUser__tabSection'>
            <Grid
              container
              spacing={2}
              classes={{ root: classes.docGridContainer }}
            >
              <Grid item xs={12} sm={6} md={2}>
                <TextField
                  size='small'
                  variant='outlined'
                  type='text'
                  label={t('licence')}
                  value={educationLicence}
                  onChange={(e) => setEducationLicence(e.target.value)}
                  fullWidth
                />
              </Grid>

              <Grid item xs={12} sm={6} md={2}>
                <TextField
                  size='small'
                  variant='outlined'
                  type='text'
                  label={t('number')}
                  value={educationNumber}
                  onChange={(e) => setEducationNumber(e.target.value)}
                  fullWidth
                />
              </Grid>

              <Grid item xs={12} sm={6} md={2}>
                <TextField
                  size='small'
                  InputLabelProps={{
                    shrink: true
                  }}
                  variant='outlined'
                  type='date'
                  label={t('issued')}
                  onChange={(e) => setEducationIssued(e.target.value)}
                  value={educationIssued}
                  fullWidth
                  // helperText={educationDateErr ? t('badDateRange') : null }
                  // error={educationDateErr ? true : false}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={2}>
                <TextField
                  size='small'
                  InputLabelProps={{
                    shrink: true
                  }}
                  variant='outlined'
                  type='date'
                  label={t('expires')}
                  onChange={(e) => setEducationExpires(e.target.value)}
                  value={educationExpires}
                  fullWidth
                  // helperText={educationDateErr ? t('badDateRange') : null}
                  // error={educationDateErr ? true : false}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={2}>
                <Autocomplete
                  options={countries}
                  getOptionLabel={(option) => option}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      size='small'
                      fullWidth
                      label={t('country')}
                      variant='outlined'
                    />
                  )}
                  value={educationCountry}
                  onChange={(e, val) => {
                    val && setEducationCountry(val)
                  }}
                />
              </Grid>
            </Grid>
          </div>
        )}
        {/* Documents section */}
        {selectedTab === 3 && (
          <div className='editUser__tabSection'>
            asdads
            <div>
              {addedDocsArr.length !== 0
                ? addedDocsArr.map((el, i) => {
                    return (
                      <Grid
                        container
                        spacing={1}
                        classes={{ root: classes.docGridContainer }}
                        key={el.id}
                      >
                        {/* Select document */}
                        <Grid item xs={12} sm={6} md={2}>
                          <Autocomplete
                            disabled={
                              !(
                                el.id !== 'passport' &&
                                el.id !== 'book' &&
                                el.id !== 'stcw' &&
                                el.id !== 'med'
                              )
                            }
                            filterOptions={certificatesOptions}
                            options={certificatesArr}
                            value={el.docId}
                            getOptionLabel={(option) => option.name}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                required
                                size='small'
                                fullWidth
                                label={t('selectDocument')}
                                variant='outlined'
                                helperText={el.docIdError && t('required')}
                                error={el.docIdError}
                              />
                            )}
                            onChange={(e, val) => {
                              val && handleInputChange(el.id, e, 'docId', val)
                            }}
                          />
                        </Grid>

                        {/* Number */}
                        <Grid item xs={12} sm={6} md={2}>
                          <TextField
                            required
                            size='small'
                            variant='outlined'
                            type='text'
                            value={el.number}
                            label={t('number')}
                            onChange={(e, val) =>
                              handleInputChange(el.id, e, 'number')
                            }
                            fullWidth
                            helperText={el.numberError && t('required')}
                            error={el.numberError}
                          />
                        </Grid>

                        {/* Place of issue */}
                        <Grid item xs={12} sm={6} md={2}>
                          <TextField
                            required
                            size='small'
                            variant='outlined'
                            type='text'
                            value={el.placeIssue}
                            label={t('placeOfIssue')}
                            onChange={(e) =>
                              handleInputChange(el.id, e, 'placeIssue')
                            }
                            fullWidth
                            helperText={el.placeIssueError && t('required')}
                            error={el.placeIssueError}
                          />
                        </Grid>

                        {/* Issued date */}
                        <Grid item xs={12} sm={6} md={2}>
                          <TextField
                            required
                            size='small'
                            variant='outlined'
                            type='date'
                            value={el.issued}
                            label={t('issued')}
                            InputLabelProps={{
                              shrink: true
                            }}
                            onChange={(e) => {
                              handleInputChange(el.id, e, 'issued')
                              validateDocDate(i)
                            }}
                            fullWidth
                            helperText={
                              el.badDateError
                                ? t('badDateRange')
                                : el.issuedError
                                ? t('required')
                                : null
                            }
                            error={!!(el.issuedError || el.badDateError)}
                          />
                        </Grid>

                        {/* Expires date */}
                        <Grid
                          item
                          xs={12}
                          sm={6}
                          md={2}
                          style={{ display: 'flex' }}
                        >
                          <TextField
                            name='expires'
                            size='small'
                            variant='outlined'
                            type='date'
                            value={el.expires}
                            label={t('expires')}
                            InputLabelProps={{
                              shrink: true
                            }}
                            onChange={(e) => {
                              handleInputChange(el.id, e, 'expires')
                              validateDocDate(i)
                            }}
                            fullWidth
                            helperText={
                              el.badDateError ? t('badDateRange') : null
                            }
                            error={el.badDateError}
                          />

                          <Tooltip
                            style={{
                              marginLeft: 10,
                              marginRight: 10,
                              marginTop: 8,
                              cursor: 'pointer'
                            }}
                            placement='right-end'
                            title={t('ifExpireDateEmptyThanUnlimited')}
                          >
                            <div>
                              <FontAwesomeIcon
                                style={{ color: systemColors.lighGrey }}
                                icon={faInfoCircle}
                              />
                            </div>
                          </Tooltip>
                        </Grid>

                        {/* Document upload */}
                        <Grid
                          item
                          xs={12}
                          sm={6}
                          md={2}
                          style={{ display: 'flex' }}
                        >
                          {/*
                           * Upload field
                           */}
                          {el.docId !== null &&
                          el.number !== '' &&
                          el.placeIssue !== '' &&
                          el.issued !== '' &&
                          el.upload === '' ? (
                            <TextField
                              required
                              size='small'
                              variant='outlined'
                              type='file'
                              label={t('uploadDocument')}
                              InputLabelProps={{
                                shrink: true
                              }}
                              onChange={(e) => {
                                const file = e.target.files
                                if (file.length > 0) {
                                  if (file[0].size > acceptedFileSize) {
                                    setFileSizeError(i, true)
                                  } else {
                                    setFileSizeError(i, false)
                                    handleInputChange(el.id, e, 'upload', file)
                                  }
                                }
                              }}
                              fullWidth
                              inputProps={{
                                accept: '.png, .jpg, .jpeg, .pdf'
                              }}
                              helperText={
                                el.uploadError
                                  ? t('required')
                                  : el.fileSizeError
                                  ? t('toBigFile')
                                  : t('acceptFormat2')
                              }
                              error={el.uploadError ? true : !!el.fileSizeError}
                            />
                          ) : el.upload !== '' && !el.replaceDocument ? (
                            <div
                              style={{
                                display: 'flex',
                                alignItems: 'center'
                              }}
                            >
                              {getDocumentFileUrl(el.id) !== '' ? (
                                <a
                                  href={getDocumentFileUrl(el.id)}
                                  target='_blank'
                                  rel='noopener noreferrer'
                                  download
                                >
                                  {t('download')}
                                </a>
                              ) : (
                                <div>
                                  {uploadingFile &&
                                  uploadingFileId === el.id ? (
                                    <FileUploadLoader />
                                  ) : (
                                    <span>{t('noFileAttached')}</span>
                                  )}
                                </div>
                              )}
                            </div>
                          ) : el.replaceDocument === true ? (
                            <TextField
                              required
                              size='small'
                              variant='outlined'
                              type='file'
                              label={t('uploadDocument')}
                              InputLabelProps={{
                                shrink: true
                              }}
                              onChange={(e) => {
                                const file = e.target.files
                                if (file.length > 0) {
                                  if (file[0].size > acceptedFileSize) {
                                    setFileSizeError(i, true)
                                  } else {
                                    setFileSizeError(i, false)
                                    setNewDocumentMsg(true)
                                    setNewDocumentData({
                                      id: el.id,
                                      file
                                    })
                                  }
                                }
                              }}
                              fullWidth
                              inputProps={{
                                accept: '.png, .jpg, .jpeg, .pdf'
                              }}
                              helperText={
                                el.uploadError
                                  ? t('required')
                                  : el.fileSizeError
                                  ? t('toBigFile')
                                  : t('acceptFormat2')
                              }
                              error={el.uploadError ? true : !!el.fileSizeError}
                            />
                          ) : (
                            <div style={{ marginTop: 8 }}>
                              {t('fillRequiredFieldsFirst')}
                            </div>
                          )}

                          {/* Replace file */}
                          {el.upload !== '' && el.replaceDocument !== true ? (
                            <Tooltip
                              style={{
                                marginLeft: 20,
                                marginTop: 8,
                                cursor: 'pointer'
                              }}
                              placement='right-end'
                              title={t('replaceFileWithAnother')}
                            >
                              <div onClick={() => replaceDocumentWithNew(i)}>
                                <FontAwesomeIcon
                                  style={{ color: systemColors.lighGrey }}
                                  icon={faSyncAlt}
                                />
                              </div>
                            </Tooltip>
                          ) : el.docId !== null &&
                            el.number !== '' &&
                            el.placeIssue !== '' &&
                            el.issued !== '' &&
                            el.upload !== '' ? (
                            <Tooltip
                              style={{
                                marginLeft: 20,
                                marginTop: 8,
                                cursor: 'pointer'
                              }}
                              placement='right-end'
                              title={t('cancelReplaceFileWithAnother')}
                            >
                              <div
                                onClick={() => cancelDocumentReplaceWithNew(i)}
                              >
                                <FontAwesomeIcon
                                  style={{ color: systemColors.lighGrey }}
                                  icon={faTimes}
                                />
                              </div>
                            </Tooltip>
                          ) : null}

                          {/* Delete document */}
                          {el.id !== 'passport' &&
                          el.id !== 'book' &&
                          el.id !== 'stcw' &&
                          el.id !== 'med' ? (
                            <Tooltip
                              style={{
                                marginLeft: 20,
                                marginTop: 8,
                                cursor: 'pointer'
                              }}
                              placement='right-end'
                              title={t('deleteDocument')}
                            >
                              <div onClick={() => removeDocument(i, el.upload)}>
                                <FontAwesomeIcon
                                  style={{ color: systemColors.lighGrey }}
                                  icon={faTrash}
                                />
                              </div>
                            </Tooltip>
                          ) : null}
                        </Grid>
                      </Grid>
                    )
                  })
                : null}

              <Button
                variant='outlined'
                classes={{
                  startIcon: classes.addDocumentButtonStartIcon,
                  outlined: classes.addDocumentButtonOutlined
                }}
                startIcon={<FontAwesomeIcon className='icon' icon={faPlus} />}
                onClick={() => addNewDocument()}
              >
                <span>{t('selectAndAddNextDocument')}</span>
              </Button>
            </div>
          </div>
        )}
        {/* Experience section */}
        {selectedTab === 4 && (
          <div className='editUser__tabSection'>
            {addedExperienceArr.map((el, i) => {
              return (
                <Grid
                  container
                  spacing={2}
                  classes={{ root: classes.docGridContainer }}
                  key={el.id}
                >
                  <Grid item xs={12} sm={6} md={2}>
                    <TextField
                      // required
                      size='small'
                      variant='outlined'
                      type='text'
                      value={el.vesselName}
                      label={t('vesselName')}
                      onChange={(e) =>
                        addExperienceInputs(el.id, e, 'vesselName')
                      }
                      fullWidth
                      // helperText={el.vesselName === '' && t('required')}
                      // error={el.vesselName === '' ? true : false}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6} md={2}>
                    <Autocomplete
                      disableClearable
                      options={flagListArr}
                      getOptionLabel={(option) => option}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          // required
                          size='small'
                          fullWidth
                          label={t('flag')}
                          variant='outlined'
                          // helperText={el.flag === null && t('required')}
                          // error={el.flag === null ? true : false}
                        />
                      )}
                      value={el.flag}
                      onChange={(e, val) => {
                        if (val) {
                          if (val === 'Other') {
                            experienceValidationSet(el.id, 'flag', true)
                          } else {
                            addExperienceInputs(el.id, e, 'flag', val)
                            experienceValidationSet(el.id, 'flag', false)
                          }
                        }
                      }}
                    />
                  </Grid>

                  {findValidation(el.id, 'flag') && (
                    <Grid item xs={12} sm={6} md={2}>
                      <TextField
                        // required
                        size='small'
                        variant='outlined'
                        type='text'
                        label={t('addFlag')}
                        onChange={(e) =>
                          addExperienceInputs(el.id, e, 'flagOther')
                        }
                        fullWidth
                        // helperText={el.flag === null ? t('required') : null }
                        // error={el.flag === null ? true : false}
                      />
                    </Grid>
                  )}

                  <Grid item xs={12} sm={6} md={1}>
                    <TextField
                      // required
                      size='small'
                      variant='outlined'
                      type='text'
                      label={t('year')}
                      value={el.year}
                      onChange={(e) => addExperienceInputs(el.id, e, 'year')}
                      fullWidth
                      // helperText={el.year === '' ? t('required') : null }
                      // error={el.year === '' ? true : false}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6} md={3}>
                    <Autocomplete
                      options={vesselTypesArr}
                      getOptionLabel={(option) => option.name}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          // required
                          size='small'
                          fullWidth
                          label={t('vesselType')}
                          variant='outlined'
                          // helperText={el.vesselType === null && t('required')}
                          // error={el.vesselType === null ? true : false}
                        />
                      )}
                      value={el.vesselType}
                      onChange={(e, val) => {
                        val && addExperienceInputs(el.id, e, 'vesselType', val)
                      }}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6} md={1}>
                    <TextField
                      // required
                      name='expires'
                      size='small'
                      variant='outlined'
                      type='text'
                      value={el.dwt}
                      label={t('dwt')}
                      onChange={(e) => addExperienceInputs(el.id, e, 'dwt')}
                      fullWidth
                      // helperText={el.dwt === '' ? t('required') : null }
                      // error={el.dwt === '' ? true : false}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6} md={2}>
                    <Autocomplete
                      options={engineTypeArr}
                      getOptionLabel={(option) => option.name}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          // required
                          size='small'
                          fullWidth
                          label={t('engineType')}
                          variant='outlined'
                          // helperText={el.engineType === null && t('required')}
                          // error={el.engineType === null ? true : false}
                        />
                      )}
                      value={el.engineType}
                      onChange={(e, val) => {
                        val && addExperienceInputs(el.id, e, 'engineType', val)
                      }}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6} md={1}>
                    <TextField
                      // required
                      name='expires'
                      size='small'
                      variant='outlined'
                      type='text'
                      label={t('hp')}
                      onChange={(e) => addExperienceInputs(el.id, e, 'hp')}
                      fullWidth
                      value={el.hp}
                      // helperText={el.hp === '' ? t('required') : null }
                      // error={el.hp === '' ? true : false}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6} md={3}>
                    <Autocomplete
                      options={positionArr}
                      getOptionLabel={(option) => option.name}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          // required
                          size='small'
                          fullWidth
                          label={t('rank')}
                          variant='outlined'
                          // helperText={el.rankId === null && t('required')}
                          // error={el.rankId === null ? true : false}
                        />
                      )}
                      value={el.rankId}
                      onChange={(e, val) => {
                        val && addExperienceInputs(el.id, e, 'rankId', val)
                      }}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6} md={2}>
                    <TextField
                      // required
                      name='expires'
                      size='small'
                      variant='outlined'
                      type='date'
                      label={t('from')}
                      InputLabelProps={{
                        shrink: true
                      }}
                      onChange={(e) =>
                        addExperienceInputs(el.id, e, 'fromDate')
                      }
                      fullWidth
                      value={el.fromDate}
                      helperText={
                        validateExperienceDate(i) ? t('badDateRange') : null
                      }
                      error={!!validateExperienceDate(i)}
                      // helperText={el.fromDate === '' ? t('required') : validateExperienceDate(i) ? t('badDateRange') : null }
                      // error={el.fromDate === '' ? true : validateExperienceDate(i) ? true : false}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6} md={2}>
                    <TextField
                      // required
                      name='expires'
                      size='small'
                      variant='outlined'
                      type='date'
                      label={t('till')}
                      InputLabelProps={{
                        shrink: true
                      }}
                      onChange={(e) =>
                        addExperienceInputs(el.id, e, 'tillDate')
                      }
                      fullWidth
                      value={el.tillDate}
                      helperText={
                        validateExperienceDate(i) ? t('badDateRange') : null
                      }
                      error={!!validateExperienceDate(i)}
                      // helperText={el.tillDate === '' ? t('required') : validateExperienceDate(i) ? t('badDateRange') : null }
                      // error={el.tillDate === '' ? true : validateExperienceDate(i) ? true : false}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6} md={2}>
                    <Autocomplete
                      options={shipOwnerArr}
                      disableClearable
                      getOptionLabel={(option) => option}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          // required
                          size='small'
                          fullWidth
                          label={t('shipOwner')}
                          variant='outlined'
                          // helperText={el.shipOwner === null && t('required')}
                          // error={el.shipOwner === null ? true : false}
                        />
                      )}
                      value={el.shipOwner}
                      onChange={(e, val) => {
                        if (val) {
                          if (val === 'Other') {
                            experienceValidationSet(el.id, 'shipOwner', true)
                          } else {
                            addExperienceInputs(el.id, e, 'shipOwner', val)
                            experienceValidationSet(el.id, 'shipOwner', false)
                          }
                        }
                      }}
                    />
                  </Grid>

                  {findValidation(el.id, 'shipOwner') && (
                    <Grid item xs={12} sm={6} md={2}>
                      <TextField
                        // required
                        size='small'
                        variant='outlined'
                        type='text'
                        label={t('addShipOwner')}
                        onChange={(e) =>
                          addExperienceInputs(el.id, e, 'shipOwnerOther')
                        }
                        fullWidth
                        // helperText={el.shipOwner === null ? t('required') : null }
                        // error={el.shipOwner === null ? true : false}
                      />
                    </Grid>
                  )}

                  <Grid item xs={12} sm={6} md={2}>
                    <Autocomplete
                      options={crewAgencyArr}
                      disableClearable
                      getOptionLabel={(option) => option}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          // required
                          size='small'
                          fullWidth
                          label={t('crewAgency')}
                          variant='outlined'
                          // helperText={el.crewAgency === null && t('required')}
                          // error={el.crewAgency === null ? true : false}
                        />
                      )}
                      value={el.crewAgency}
                      onChange={(e, val) => {
                        if (val) {
                          if (val === 'Other') {
                            experienceValidationSet(el.id, 'crewAgency', true)
                          } else {
                            addExperienceInputs(el.id, e, 'crewAgency', val)
                            experienceValidationSet(el.id, 'crewAgency', false)
                          }
                        }
                      }}
                    />
                  </Grid>

                  {findValidation(el.id, 'crewAgency') && (
                    <Grid item xs={12} sm={6} md={2}>
                      <TextField
                        // required
                        size='small'
                        variant='outlined'
                        type='text'
                        label={t('addCrewAgency')}
                        onChange={(e) =>
                          addExperienceInputs(el.id, e, 'crewAgencyOther')
                        }
                        fullWidth
                        // helperText={el.crewAgency === null ? t('required') : null }
                        // error={el.crewAgency === null ? true : false}
                      />
                    </Grid>
                  )}

                  {/*
                   * Buttons
                   */}
                  <Grid item xs={12} sm={6} md={1}>
                    <div style={{ display: 'flex' }}>
                      {/*
                       * Remove
                       */}
                      <Tooltip
                        style={{
                          marginLeft: 10,
                          marginRight: 10,
                          marginTop: 8,
                          cursor: 'pointer'
                        }}
                        placement='right-end'
                        title={t('removeExperience')}
                      >
                        <div
                          className='addNewEmployee__addRemove'
                          onClick={() => removeExperience(i)}
                        >
                          <FontAwesomeIcon
                            style={{ color: systemColors.lighGrey }}
                            icon={faTrash}
                          />
                        </div>
                      </Tooltip>

                      {/*
                       * Copy
                       */}
                      <Tooltip
                        style={{
                          marginLeft: 10,
                          marginRight: 10,
                          marginTop: 8,
                          cursor: 'pointer'
                        }}
                        placement='right-end'
                        title={t('copy_experience')}
                      >
                        <div
                          className='addNewEmployee__addRemove'
                          onClick={() => copyExperience(el)}
                        >
                          <FontAwesomeIcon
                            style={{ color: systemColors.lighGrey }}
                            icon={faCopy}
                          />
                        </div>
                      </Tooltip>
                    </div>
                  </Grid>
                </Grid>
              )
            })}

            <Button
              variant='outlined'
              classes={{
                startIcon: classes.addDocumentButtonStartIcon,
                outlined: classes.addDocumentButtonOutlined
              }}
              startIcon={<FontAwesomeIcon className='icon' icon={faPlus} />}
              onClick={() => addNewExperience()}
            >
              <span>{t('selectAndAddNextExperience')}</span>
            </Button>
          </div>
        )}
        {/* Crew or marine agencies section */}
        {selectedTab === 5 && (
          <div className='editUser__tabSection'>
            {addedContactsArr.map((el, i) => {
              return (
                <Grid
                  container
                  spacing={2}
                  classes={{ root: classes.docGridContainer }}
                  key={el.id}
                >
                  <Grid item xs={12} sm={6} md={2}>
                    <TextField
                      // required
                      size='small'
                      variant='outlined'
                      type='text'
                      value={el.crewAgency}
                      label={t('crewAgency')}
                      onChange={(e) => addContactInput(el.id, e, 'crewAgency')}
                      fullWidth
                      // helperText={el.crewAgency === '' && t('required')}
                      // error={el.crewAgency === '' ? true : false}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6} md={2}>
                    <Autocomplete
                      disableClearable
                      options={countries}
                      getOptionLabel={(option) => option}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          // required
                          size='small'
                          fullWidth
                          label={t('country')}
                          variant='outlined'
                          // helperText={el.country === null && t('required')}
                          // error={el.country === null ? true : false}
                        />
                      )}
                      value={el.country}
                      onChange={(e, val) => {
                        val && addContactInput(el.id, e, 'country', val)
                      }}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6} md={2}>
                    <TextField
                      // required
                      size='small'
                      variant='outlined'
                      type='text'
                      value={el.contactPerson}
                      label={t('contactPerson')}
                      onChange={(e) =>
                        addContactInput(el.id, e, 'contactPerson')
                      }
                      fullWidth
                      // helperText={el.contactPerson === '' && t('required')}
                      // error={el.contactPerson === '' ? true : false}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6} md={2}>
                    <TextField
                      size='small'
                      variant='outlined'
                      type='email'
                      value={el.email}
                      label={t('email')}
                      onChange={(e) => addContactInput(el.id, e, 'email')}
                      fullWidth
                    />
                  </Grid>

                  <Grid item xs={12} sm={6} md={2}>
                    <TextField
                      // required
                      size='small'
                      variant='outlined'
                      type='tel'
                      value={el.phone}
                      label={t('phone')}
                      onChange={(e) => addContactInput(el.id, e, 'phone')}
                      fullWidth
                      // helperText={el.phone === '' && t('required')}
                      // error={el.phone === '' ? true : false}
                    />
                  </Grid>

                  {/* Remove contact */}
                  <Grid item xs={12} sm={6} md={1}>
                    <Tooltip
                      style={{
                        marginLeft: 10,
                        marginRight: 10,
                        marginTop: 8,
                        cursor: 'pointer'
                      }}
                      placement='right-end'
                      title={t('removeContact')}
                    >
                      <div
                        className='addNewEmployee__addRemove'
                        onClick={() => removeContact(i)}
                      >
                        <FontAwesomeIcon
                          style={{ color: systemColors.lighGrey }}
                          icon={faTrash}
                        />
                      </div>
                    </Tooltip>
                  </Grid>
                </Grid>
              )
            })}

            <Button
              variant='outlined'
              classes={{
                startIcon: classes.addDocumentButtonStartIcon,
                outlined: classes.addDocumentButtonOutlined
              }}
              startIcon={<FontAwesomeIcon className='icon' icon={faPlus} />}
              onClick={() => addNewContact()}
            >
              <span>{t('selectAndAddAgency')}</span>
            </Button>
          </div>
        )}
        {/* Physical state */}
        {selectedTab === 6 && (
          <div className='editUser__tabSection'>
            <Grid
              container
              spacing={2}
              classes={{ root: classes.docGridContainer }}
            >
              <Grid item xs={12} sm={6} md={2}>
                <Autocomplete
                  disableClearable
                  options={heightArr}
                  getOptionLabel={(option) => option}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      // required
                      size='small'
                      fullWidth
                      label={t('heightCm')}
                      variant='outlined'
                      // helperText={heightErr && t('required')}
                      // error={heightErr ? true : false}
                    />
                  )}
                  value={height}
                  onChange={(e, val) => {
                    val && setHeight(val)
                  }}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={2}>
                <Autocomplete
                  disableClearable
                  options={weightArr}
                  getOptionLabel={(option) => option}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      // required
                      size='small'
                      fullWidth
                      label={t('weightKg')}
                      variant='outlined'
                      // helperText={weightErr && t('required')}
                      // error={weightErr ? true : false}
                    />
                  )}
                  value={weight}
                  onChange={(e, val) => {
                    val && setWeight(val)
                  }}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={2}>
                <Autocomplete
                  disableClearable
                  options={shoesSizeArr}
                  getOptionLabel={(option) => option}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      // required
                      size='small'
                      fullWidth
                      label={t('shoes')}
                      variant='outlined'
                      // helperText={shoesSizeErr && t('required')}
                      // error={shoesSizeErr ? true : false}
                    />
                  )}
                  value={shoesSize}
                  onChange={(e, val) => {
                    val && setShoesSize(val)
                  }}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={2}>
                <Autocomplete
                  disableClearable
                  options={clothesSizeArr}
                  getOptionLabel={(option) => option}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      // required
                      size='small'
                      fullWidth
                      label={t('clothes')}
                      variant='outlined'
                      // helperText={clothesSizeErr && t('required')}
                      // error={clothesSizeErr ? true : false}
                    />
                  )}
                  value={clothesSize}
                  onChange={(e, val) => {
                    val && setClothesSize(val)
                  }}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={2}>
                <Autocomplete
                  disableClearable
                  options={hairColorArr}
                  getOptionLabel={(option) => option}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      // required
                      size='small'
                      label={t('hairColor')}
                      variant='outlined'
                      // helperText={hairColorErr && t('required')}
                      // error={hairColorErr ? true : false}
                    />
                  )}
                  value={hairColor}
                  onChange={(e, val) => {
                    val && setHairColor(val)
                  }}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={2}>
                <Autocomplete
                  disableClearable
                  options={eyeColorArr}
                  getOptionLabel={(option) => option}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      // required
                      size='small'
                      fullWidth
                      label={t('eyeColor')}
                      variant='outlined'
                      // helperText={eyeColorErr && t('required')}
                      // error={eyeColorErr ? true : false}
                    />
                  )}
                  value={eyeColor}
                  onChange={(e, val) => {
                    val && seteyeColor(val)
                  }}
                />
              </Grid>
            </Grid>
          </div>
        )}
        {/* Comment */}
        {selectedTab === 7 && (
          <div className='editUser__tabSection'>
            <Grid
              container
              spacing={2}
              classes={{ root: classes.docGridContainer }}
            >
              <TextField
                size='small'
                variant='outlined'
                type='text'
                value={comment}
                label={t('comment')}
                onChange={(e) => setComment(e.target.value)}
                fullWidth
                multiline
                rows={5}
              />
            </Grid>
          </div>
        )}
      </div>
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    agencyData: state.agencyDataRed.obj,
    showGeneratedPdfBox: state.showGeneratedPdfBoxRed.bool,
    agencyUserData: state.agencyUserDataRed.obj
  }
}

export default connect(mapStateToProps)(CrewEmployeeEditProfile)
